import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { PlayerProvider } from "./context/PlayerContext";
import { SettingsProvider } from "./context/SettingsContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { AudioPlayer } from "./components/AudioPlayer";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Archive from "./pages/Archive";
import EpisodeDetail from "./pages/EpisodeDetail";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Pricing from "./pages/Pricing";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Auth from "./pages/Auth";
import AuthCallback from "./pages/AuthCallback";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import PaymentReturn from "./pages/PaymentReturn";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Header />
      <main className="min-h-screen pb-32">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/episodi" element={<Archive />} />
          <Route path="/episodi/:id" element={<EpisodeDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/abbonamenti" element={<Pricing />} />
          <Route path="/chi-sono" element={<About />} />
          <Route path="/contatti" element={<Contact />} />
          <Route path="/accedi" element={<Auth />} />
          <Route path="/pagamento" element={<PaymentReturn />} />
          <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
        </Routes>
      </main>
      <Footer />
      <AudioPlayer />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <PlayerProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <AppRouter />
          </BrowserRouter>
        </PlayerProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
